export default {
  navbar: {
    Home: '首页',
    ProductInfo: '产品介绍',
    Contact: '合作伙伴',
    Join: '招纳贤士',
    About: '关于我们',
    TMS: 'TMS运输管理系统',
    SCC: 'SCC订单协同平台',
    DAT: 'DATAHUB数据交换平台',
    OMS: 'OMS订单管理系统',
    WCS: 'WCS设备控制系统',
    WMS: 'WMS仓储管理系统',
    zh: '简体中文'
  },
  // 首页
  Home: {
    bannerTitle: 'MAG TMS运输管理',
    bannerDetail: '智能化 .  透明化  .  可视化  .  全程化',
    bannerButton: '点击了解',
    bannerTitle1: '我们优化您的供应链',
    bannerDetail1: '适用于仓储配送和生产制造的整合自动化物流解决方案',
    bannerTitle2: 'MAG SCC 订单协同平台',
    bannerDetail2: '打造卓越供应链管理中心',
    system1: {
      Title: 'WMS仓储管理系统',
      Detail1: '真正的产品化,精细化仓储管理系统',
      Detail2: '高度适用性、高度灵活性',
      Detail3: '智能化物流仓库的大脑',
      Detail4: '面向仓库效率提升'
    },
    system2: {
      Title: 'OMS订单管理系统',
      Detail1: '多平台、多仓、多店集成管理',
      Detail2: '线上线下，高效协同',
      Detail3: '强大报表功能，无惧大数据查询'
    },
    system3: {
      Title: 'TMS物流管理系统',
      Detail1: '智能化·透明化·全程化',
      Detail2: '面向运输管理5大挑战的',
      Detail3: '专业解决方案'
    },
    system4: {
      Title: 'SCC订单协同平台',
      Detail1: '多系统协同',
      Detail2: '可配置化自动化引擎',
      Detail3: '订单生命周期管理'
    },
    LookDetail: '查看详情',
    // 方案
    scheme: {
      Title: '您的供应链优化计划',
      Name1: 'MAG WMS仓储管理系统',
      NameCopy: '绩效优化软件',
      Detail1: {
        Detail1: '集成数百家行业企业业务实践,',
        Detail2: '高度产品化，涵盖仓库全业务需求',
        Detail3: '智能化作业指导，优化的作业流程和策略',
        Detail4: '全渠道业务支持，无纸化作业管理'
      },
      Name2: 'MAG TMS运输管理系统',
      Detail2: {
        Detail1: '运输管理过程信息化，可视化，智能化,',
        Detail2: '静态线路规划和动态线路优化',
        Detail3: '承运商管理，协同订单管理',
        Detail4: '智能化运输调度，可视化跟踪与异常处理'
      },
      Name3: 'MAG DATAHUB数据交换平台',
      Detail3: {
        Detail1: '系统间数据交换与对接,',
        Detail2: '软件系统与硬件系统的对接',
        Detail3: '对接主流ERP软件、物流自动化设备',
        Detail4: '多客户、异构系统、大数据量处理能力'
      },
      Name4: 'MAG SCC订单协同平台',
      Detail4: {
        Detail1: '全网库存，让库存管理更容易、更透明',
        Detail2: '多系统协同，供应商、客户开放平台，服务整体供应链',
        Detail3: '可配置自动化引擎，应用场景多，极大提升整体效率',
        Detail4: '订单全生命周期，灵活节点配置，多方式消息预警'
      },
      Name5: 'MAG WCS设备控制系统',
      Detail5: {
        Detail1: '协同多种物流设备并采用统一控制平台,',
        Detail2: '完美支持各类WMS、ERP等系统对接',
        Detail3: '整体考虑设备的控制优化',
        Detail4: '便于未来设备调整与扩展'
      },
      Name6: 'MAG OMS订单管理系统',
      Detail6: {
        Detail1: '全渠道订单管理，对接多平台',
        Detail2: '订单自动合并、拆分',
        Detail3: '自动匹配仓库和快递',
        Detail4: '多部门、多角色协同办公'
      },
      Button: '了解更多'
    },
    // 客户案例
    CustomerCase: {
      Title: '客户案例',
      Detail: '领先的管理理念：行业高端的客户群体，业内最成熟最领先的管理理念；深厚的行业积累：10 年以上多家知名企业信息系统研发与实施经验的深厚积累；专业的人才储备：资深专家团队，高素质的研发团队；全面的应用功能：功能完备的产品线，强大的业务整合能力与研发能力；可靠的产品质量：严格的研发流程与项目质量控制；优质的售后服务：迅速、优质、有效的特色售后服务的保证。',
      Case: {
        Case1: {
          Title: '卡车航班服务',
          Detail1: '卡车航班操作系统是MAG在2019年推出的专门为CV、7L、RU等航空公司卡车航班服务的专业系统解决方案，系统为航空公司提供了包括客户管理、卡车服务商管理、货物管理、报文信息管理、卡车航班管理、财务管理、权限管理、静态数据管理、报表统计等在内几大功能。卡车操作系统通过SITA电报和航空公司及卡车服务商进行自动电子数据交换，进一步提高操作效率。'
        },
        Case2: {
          Title: '智能化仓库',
          Detail1: '巴斯夫是全球领先的化工公司-- The Chemical Company。BASF在德国与Bayer，Hoechest并列驰名，是德国三大化工厂之一，公司的产品范围包括化学品、塑料、特性化学品、农用产品、精细化学品以及原油和天然气。',
          Detail2: '应用美格WMS方案，显著提升了仓库的利用率和仓库作业全流程可视化管理。'
        },
        Case3: {
          Title: '第三方物流',
          Detail1: '中远海运物流是中远海运集团全资子公司, 是集团唯一的整合物流服务平台公司，是中国最大的国际化第三方物流企业。',
          Detail2: '针对中远海运物流对于先进的TMS的迫切需求，美格运用丰富的行业经验和MAG TMS产品实现对中远海运运输管理的整体流程的改造，将所有业务串联成整体，为中远海运建立了统一完整的运输业务管理平台。'
        },
        Case4: {
          Title: '第四方物流',
          Detail1: '某全球性的免税品集团公司，随着战略的调整和业务快速增长，遇到一系列新的挑战。MAG 4PL是拥有广泛的行业背景，通过拥有的信息技术、整合能力以及其他在专业领域的资源和能力为客户提供综合的、定制化的供应链解决方案和咨询服务。',
          Detail2: '依托业务个性化定制的供应链可视化平台（MAG SCC），优化供应链的流程，帮助企业实现降低成本和有效整合资源，提高供应链的效率。'
        },
        Case5: {
          Title: '自贸区可视化平台',
          Detail1: '某全球知名服装集团，作为快消品牌，物流是该集团的“利器”之一，这意味着对速度的苛刻和挑剔。',
          Detail2: '利用MAG自贸区可视化系统，在“区港一体当日快速进出模式”下，创造了飞机落地后5小时货物出区的最快纪录。',
          Detail3: '主要功能包括：进出口管理、贸易合规、保税仓储管理、加贸管理、金关二期、配送管理等'
        },
        Case6: {
          Title: '配送管理系统',
          Detail1: '某全球汽车制造集团，自贸区摩托车全国配送项目',
          Detail2: 'MAG TMS全面支持干线物流，区域配送，车辆追踪，智能调度，快速结算。',
          Detail3: '支持移动设备应用，实现全面的跟踪，全面的信息可视化.'
        }
      }
    },
    // 订货数量
    OrderQuantity: {
      Billion: '亿',
      year: '年',
      OrderNum: '累计订单量',
      OrdeUser: '企业级用户',
      hangye: '聚焦行业',
      yanfa: '产品研发',
      content1: '美/格/运/输/管/理/云/平/台',
      content2: '专/业/物/流/管/理'
    },
    // 企业选择
    CompanyChoose: {
      Title: '众多头部企业的选择',
      button1: '物流企业',
      button2: '服装时尚',
      button3: '汽车&工业制造',
      button4: '医药&化工'
    }
  },
  // 合作伙伴
  Contact: {
    Title: '我们的合作伙伴',
    Detail1: '为方便地为客户服务，截止目前，美格已经与SAP、Oracle、DEMATIC等多加知名企业深入合作，从而让MAG运输协同平台可以快速实施，并迅速对接企业已有平台与系统，让在途运输管理迅速成为企业物流管理供应链中的新武器。',
    Detail2: '美格成功的搭建了一套完整的创新价值链。通过整合MAG内部各个团队及MAG外部生态圈的各种专业资源，为客户提供优质的创新实践'
  },
  About: {
    Title: '我们是美格网络 了解我们',
    smallTitle: '创新 分享 成长',
    list: {
      list1: {
        Title: '关于MAG',
        smallTitle: 'TMS致力于缔造运输新生态，让运输更智能',
        Detail: 'TMS是国内知名的运输管理云平台，拥有运输管理云系统TMS和综合运输外包业务全橙服务，从分析、采购、管理到支付，多方位帮助客户快速优化供应链，降本增效，引领创新。'
      },
      list2: {
        Title: 'MAG愿景',
        smallTitle: '领创非凡 Make a Difference',
        Detail: '革新供应链，改进商业模式，为社会创造价值；引领创新，成就非凡，让世界大有不同。'
      },
      list3: {
        Title: 'MAG使命',
        smallTitle: '让运输更智能 Make Transport Smart',
        Detail: '用科技与服务打造运输新生态，赋能数据驱动、互联互通的供应链，让运输更轻松'
      }
    },
    address: '上海市长宁区延安西路2299号世贸商城2506室'
  },
  // WCS
  WCS: {
    Title: 'MAG WCS设备控制系统',
    smallTitle: '全渠道    智能化    协同化',
    name: '系统简介',
    list: {
      list1: {
        Title: '收货存储',
        Detail: '通过对诸多仓库作业环节，业务流程进行电子化协同处理，使得库房作业人力效能尽可能最大化。'
      },
      list2: {
        Title: '拣选',
        Detail: '引入大量电子化、自动化物品设备、同时打通这些物品设备和 WMS 系统的实时联通，应用系统可以让仓库管理更简单、更高效，自动化程度更高，甚至无需专业的岗位团队就能完成日常的管理工作'
      },
      list3: {
        Title: '分拣发货',
        Detail: '引入 RFID 等技术手段，利用信息系统稳定准确的特性，及时介入替换部分人工操作，减少系统的出错场景和概率，如仓库发货，丢件、漏算等情况在仓库等等。'
      },
      list4: {
        Title: '大数据监控',
        Detail: '引入 RFID 等技术手段，利用信息系统稳定准确的特性，及时介入替换部分人工操作，减少系统的出错场景和概率，如仓库发货，丢件、漏算等情况在仓库等等。'
      }
    },
    content: {
      Title: '设备控制系统',
      list1: {
        Title: '账号管理',
        Detail1: '账号管理 / 权限管理 / 角色管理'
      },
      list2: {
        Title: '设备管理',
        Detail1: '设备主数据管理 / 设备运行数据收集',
        Detail2: '设备故障日志'
      },
      list3: {
        Title: '任务管理',
        Detail1: '任务创建/完成提醒 / 任务协调/分发',
        Detail2: '任务负载均衡机制'
      },
      list4: {
        Title: '对接协议',
        Detail1: '设备底层PLC通讯协议 / 单片机通讯协议',
        Detail2: ' TCPIP通讯协议'
      },
      list5: {
        Title: '报表管理',
        Detail1: '设备报表 / 任务报表 / 统计报表'
      },
      list6: {
        Title: 'SCADA',
        Detail1: '图形监控界面 / 设备管理现场监控PI'
      }
    },
    Title1: '我们的客户'
  },
  // DAT
  DAT: {
    Title: 'MAG DATAHUB数据交换平台',
    smallTitle: '链接 · 协同 ·共享',
    name: '我们的五大系统',
    name1: 'ERP系统',
    name2: '物流系统',
    name3: '快递系统',
    name4: '电商平台',
    name5: '硬件驱动系统',
    system: {
      Title: '系统特点',
      Title_1: '高性能架构+数据安全',
      Title_2: '自定义配置，场景灵活应对',
      Title_3: '全方位数据接口支持，大数据支持',
      Title_4: '实时监控，直观，便捷的信息展示'
    }
  },
  // OMS
  OMS: {
    Title: 'MAG OMS订单管理系统',
    smallTitle: '全渠道    智能化    协同化',
    name: '系统优势',
    name1: '线上线下协同，高效工作',
    name2: '店家- 平台 - 仓库 - 运输 - 客户多维度管理多平台管理',
    name3: '全方位标准数据接口支持',
    name4: '高拓展性和可配置性',
    name5: '大数据报表功能强大，智慧决策机制加持',
    name6: '跨境业务完美支持',
    name7: '智能任务调度分配机制，性能负载均衡',
    list: {
      Title: '系统功能总览',
      list1: {
        Title: '收货存储',
        Detail1: '快递策略 最小运费/ 体积判断 / 重量判断',
        Detail2: '多品指定 / 单品指定',
        Detail3: '会员营销 / 店铺指定'
      },
      list2: {
        Title: '仓库策略',
        Detail1: '距离优先 / 区域优先 / 库存优先',
        Detail2: '单品优先级 / 多品优先级',
        Detail3: '区域检测 / 库存检测'
      },
      list3: {
        Title: '会员策略',
        Detail1: '会员排名 / 叠加 / 停止 / 会员 / 满送 / 买送 翻倍 / 区域 / 组合 / 优先级 / 关键字 / 限'
      },
      list4: {
        Title: '订单策略',
        Detail1: '免审策略 / 合并策略 / 拆单策略 / 转单策略',
        Detail2: '发货策略 / 缺货转仓策略 / 缺货解除策略',
        Detail3: '组合商品策略 / 库存调配策略',
        Detail4: '快递单号策略 / 京配策略'
      },
      list5: {
        Title: '库存策略',
        Detail1: '防止批量下架 / 差异同步配置',
        Detail2: '店铺同步比例设置 / 套餐比例配置',
        Detail3: 'SKU同步比例设置 / 库存警戒配置',
        Detail4: '预售同步设置 / 库存共享配置'
      },
      list6: {
        Title: 'BI分析',
        Detail1: '商品销售排行 / 店铺销售汇总 / 平台销售汇总',
        Detail2: '仓库销售汇总 / 城市销售排行 / 省份销售排行',
        Detail3: '店铺价格比较 / 滞销商品',
        Detail4: '售前KPI / 售后KPI / 结算KPI',
        Detail5: '退件登记KPI / 退件处理KPI / 仓库发货KPI',
        Detail6: '快递发货KPI'
      }
    }
  },
  TMS: {
    Title: 'MAG TMS运输管理系统',
    smallTitle: '智能化   透明化   全程化',
    name: '直击运输管理5大痛点',
    name1: '成本控制难',
    name2: '执行与监控难',
    name3: '满足各个行业需求多样性难',
    name4: '运输计划和KPI考核难',
    name5: '解决系统拓展与集成性难',
    name6: '美格物流运输解决方案',
    name6Detail: '将货主、物流公司、承运商以及司机端全流程连接，打造从订单分配到货物签收的全流程可视化、信息化、数字化界面，美格TMS是您信息化时代实现运输管理智能化、数字化的基础设施',
    list: {
      name: '系统功能总览',
      list1: {
        Title: '基础设置',
        Detail1: '客户档案 / 产品档案',
        Detail2: '承运商档案 / 行政区域 / 提送货地址',
        Detail3: '路线管理 / 车辆管理 / 车型管理'
      },
      list2: {
        Title: '业务规则',
        Detail1: '系统配置 / 列表配置',
        Detail2: '调度规则 / 跟踪规则 / 消息推送',
        Detail3: '公告栏管理 / 定时器'
      },
      list3: {
        Title: '订单管理',
        Detail1: '订单建立 / 订单审核',
        Detail2: '订单查询 / 订单拆分'
      },
      list4: {
        Title: '调度管理',
        Detail1: '提货调度 / 干线调度',
        Detail2: '市内调度 / 波次匹配'
      },
      list5: {
        Title: '跟踪执行',
        Detail1: '装车 / 发运确认 / 在途跟踪',
        Detail2: '到达签收 / 卸货入库 / 回单管理',
        Detail3: '异常管理 / 影像保存'
      },
      list6: {
        Title: '统计分析',
        Detail1: '送货及时率 / 签收完好率',
        Detail2: '人员作业指标 / 运输工具负荷',
        Detail3: '运输费用指标 / 客户满意度',
        Detail4: '承运商考核 / 自定义查询 / 自定义报表'
      },
      list7: {
        Title: '计费管理',
        Detail1: '费率设置 / 费用账单 / 账单发票',
        Detail2: '账单核销 / 费用审核',
        Detail3: '应收账单 / 应付账单'
      },
      list8: {
        Title: 'APP',
        Detail1: '提货 / 卸货 / 装车',
        Detail2: '签收 / 运单查询 / 图片上传',
        Detail3: '接口管理 / 预警'
      }
    }
  },
  // WMS
  WMS: {
    Title: 'MAG WMS仓储管理系统',
    smallTitle: '高效 · 精准 · 智能 · 自动 · 可追溯',
    name: '系统领先优势',
    list: {
      list1: {
        Title: '降低人力成本',
        Detail1: '通过对诸多仓库作业环节，业务流程进行电子化协同处理，引入 IT 能力支撑，将一大部分原先需要人工作业的功能利用信息化替换，将人员组织协调工作最大化的交由系统处理，使得库房作业人力效能尽可能最大化。'
      },
      list2: {
        Title: '操作自动化',
        Detail1: '引入大量电子化、自动化物品设备、同时打通这些物品设备和 WMS 系统的实时联通，应用系统可以让仓库管理更简单、更高效，自动化程度更高，甚至无需专业的岗位团队就能完成日常的管理工作了。'
      },
      list3: {
        Title: '减少差错率',
        Detail1: '利用信息系统稳定准确的特性，及时介入替换部分人工操作，减少系统的出错场景和概率，如仓库发货，丢件、漏算等情况在仓'
      },
      list4: {
        Title: '产品可追溯',
        Detail1: '产品追溯——WMS 系统业务数据模型的建立可以对产品追溯、质量管理、产品效期跟踪等方面做了特别的控制，形成来源可查、去向可追、责任可究的产品全链条追溯体系。'
      },
      list5: {
        Title: '智能化盘点',
        Detail1: '无论是库位管理、批次管理，处处体现精细化理念。 详尽的业务规则，涵盖仓库作业全过程，从容高效处理复杂作业流程。通过看板、图形化展示工具等，实现可视化管理。'
      },
      list6: {
        Title: '紧密连接业务',
        Detail1: '与上下游业务的衔接更紧密、及时——通过 WMS 系统的引入，与 ERP，TMS 等业务环节所使用的系统可以直接对接，减少业务环节对接因为信息化程度不同导致的不畅通。'
      },
      list7: {
        Title: '深化经营分析管控',
        Detail1: '深化经营分析管控——通过大数据积累和多维度分析，为决策者提供快速决策支撑，建立全方位的仓库作业业务实时监控和预警机制，优化仓库运营效率。'
      }
    }
  },
  // SCC
  SCC: {
    Title: 'MAG SCC订单协同平台',
    smallTitle: '高效 · 精准 · 智能 · 自动 · 可追溯',
    name: '系统简介',
    content1: {
      Title: '卓越中心',
      list1: {
        Title: '需求计划',
        name1: '统计预算',
        name2: '需求感知',
        name3: '主数据<br/>管理',
        name4: '促销计划<br/>管理'
      },
      list2: {
        Title: '库存控制',
        name1: '各级库存<br/>管控',
        name2: '需求供应<br/>协同和<br/>监督',
        name3: '库存<br/>调配',
        name4: '规则<br/>管理'
      },
      list3: {
        Title: '供应计划',
        name1: 'SOP<br/>制定',
        name2: '订单<br/>跟踪',
        name3: '补货<br/>管理',
        name4: '货运<br/>跟踪'
      },
      list4: {
        Title: '供应链控制',
        name1: '供应链<br/>战略',
        name2: '3PL/保险优化 (价格、合约)',
        name3: '网络设计 和优化',
        name4: '关务<br/>管理',
        name5: '运输<br/>计划',
        name6: '成本<br/>控制'
      },
      list5: {
        Title: '端到端协同',
        name1: '数据分析及梳理',
        name2: '全球营运流程控制',
        name3: '系统的持续升级',
        name4: '政策和职权的定义',
        name5: 'KPI定义/监督'
      },
      list6: {
        Title: 'SCC(供应链协同)',
        name1: '供应商',
        name2: '客户',
        name3: '3PL',
        name4: '经销商'
      },
      list7: {
        Title: 'DATAHUB(主数据)'
      },
      list8: {
        Title: 'WMS(仓储系统)',
        name1: '在途库存',
        name2: '第三方仓库'
      },
      list9: {
        Title: 'OMS(订单)'
      }
    },
    content2: {
      Title: '系统功能',
      list1: {
        Title: '预测计划',
        name1: '统计预测',
        name2: '多场景模拟规划（主要用于库存调配）',
        name3: '跨部门合作的计划管理',
        name4: '全球供应网络规划',
        name5: '总需求计划和细化的需求计划',
        name6: '供应商能力规划',
        name7: '运输线路规划',
        name8: '结果分析(KPI reporting)',
        name9: '全球库存可视化'
      },
      list2: {
        Title: '订单管理',
        name1: '订单批复',
        name2: '订单平台输入',
        name3: '生成销售订单并库存暂留',
        name4: '多层级订单需求管理 (ATP)',
        name5: '关封跟踪',
        name6: '订单合并',
        name7: '终端收货管理',
        name8: '配送端货运轨迹跟踪',
        name9: '到货通知',
        name10: '文件管理',
        name11: '配送状态显示',
        name12: '数据电子传输'
      },
      list3: {
        Title: '采购管理',
        name1: '操作规范',
        name2: '产品主数据',
        name3: '品牌商物流管理',
        name4: '采购订单跟踪',
        name5: '订单、发票校验（支持3方贸易）',
        name6: '差错自动通知',
        name7: '采购批量控制',
        name8: 'BACKORDER 管理',
        name9: '数据传输自动化',
        name10: '集货管理',
        name11: '到货异常管理',
        name12: '单据审核',
        name13: '货物到货前通知',
        name14: '品牌供应商KPI管理',
        name15: '收货管理',
        name16: '数据电子传输'
      },
      list4: {
        Title: '运输管理',
        name1: 'SOP管理',
        name2: '运输线路分析（国内，国际）',
        name3: '途中货物管理',
        name4: '补货管理',
        name5: '越库配送',
        name6: '盘点管理',
        name7: '退货管理',
        name8: '发运需求和批复',
        name9: '不符合项报告',
        name10: '破损，索赔，保费管理',
        name11: '供应商（仓储，物流）考核',
        name12: '单据管理',
        name13: '预警管理',
        name14: '运输模式分析',
        name15: '贸易条款管理',
        name16: '货量分析',
        name17: '运输节点管控',
        name18: '数据电子传输'
      },
      list5: {
        Title: '优化管理',
        name1: '发票管理',
        name2: '关务管理',
        name3: '库存管理 （含效期管理）',
        name4: '成本管理',
        name5: '差异分析',
        name6: '订单管理 （含配送端）',
        name7: '运输模式线路优化管理',
        name8: '主数据管理',
        name9: '保险管理',
        name10: '运费管理 （国际，国内）'
      }
    }
  },
  // 招纳贤士
  Join: {
    Title: '物流行业最佳雇主',
    smallTitle: '创新 分享 成长',
    list: {
      list1: {
        Title: '物流行业最佳雇主',
        Detail1: 'WMS中国品牌;',
        Detail2: '超过40% 的年增长率行业领先；',
        Detail3: '技术/ 解决方案领先，客户领先。'
      },
      list2: {
        Title: '分享成功分享财富',
        Detail1: '不仅分享成功，也分享财富;',
        Detail2: '凝聚了聪明有活力的一群人;',
        Detail3: '超四分之一的五年以上荣誉员工'
      },
      list3: {
        Title: '专业培训成长动力',
        Detail1: '每月至少一次的专业培训;',
        Detail2: '让员工保持知识领先及业务精熟;',
        Detail3: '为员工个人成长提供源源动力。'
      },
      list4: {
        Title: '独特文化人性关怀',
        Detail1: '关心员工健康胜过单纯追求业绩;',
        Detail2: '水果时间、自有农场、每季徒步;',
        Detail3: '海外年会，带你看世界'
      }
    },
    banner: '年会掠影',
    info: {
      Title: '招聘信息',
      list: {
        name1: 'WMS高级咨询顾问（10名)',
        name2: 'TMS高级咨询顾问（5名）',
        name3: 'Java 开发（5名）',
        name4: 'DBA数据库管理（2名）',
        Title: '岗位职责:',
        Detail1: '1. 负责实施WMS项目，包括项目调研、业务蓝图设计、功能需求书撰写、安装配置及培训等，确保项目按时按质完成；',
        Detail2: '2. 和客户保持密切沟通，解决项目中遇到的问题；',
        Detail3: '3. 负责项目实施团队与开发团队的工作沟通和协调；',
        Detail4: '4. 总结项目实施管理经验，丰富实施知识库，树立样板客户。',
        Detail5: '工作地点：上海、北京、广州、深圳、武汉、成都、合肥、青岛',
        addressWuhan: '工作地点：武汉',
        addressDataBase: '工作地点：北京、上海'
      }
    }
  },
  Footer: {
    nav: '网站导航',
    contact: {
      Title: '联系方式',
      tel: '电话：021-54500923',
      email: '邮箱：marketing@mag-chn.com',
      postal: '邮编：200232',
      address: '地址：上海市长宁区延安西路2299号世贸商城2506室 智链寰宇',
      weixin: '微信公众号',
      scan: '手机微信扫一扫',
      copyRight: 'Copyright @ 2020 mag-chn.com 沪ICP备19028688号'
    }
  }
}
